var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m10.869 27.463-10.4-10.4a1.6 1.6 0 0 1 0-2.263l2.263-2.263a1.6 1.6 0 0 1 2.263 0l7.006 7.006L27.007 4.537a1.6 1.6 0 0 1 2.263 0L31.533 6.8a1.6 1.6 0 0 1 0 2.263l-18.4 18.4a1.6 1.6 0 0 1-2.263 0z"}));
}

Check.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Check;

Check.default = Check;
